import { Card, Typography, Divider, Box, Stack, Icon, Paper, Link } from '@ace-clublabs/shared-component-library';
import { useGlobalState } from '../../state/state';
import { generateMembershipCardUrl } from '../../utils/generateURL';

export interface ConfirmationItemDetails {
  title?: string;
  details?: string | JSX.Element;
  effectiveDate?: string;
  iconName?: any;
  cardLastFour?: string;
  className?: string;
  autoPayEnrolled?: boolean;
  isMonthlyBillPlan?: boolean;
  downloadMembershipCard?: boolean;
  mask?: boolean;
}

export interface ConfirmationCardProps {
  cardTitle: string;
  items: ConfirmationItemDetails[];
}

export const ConfirmationCard = ({ cardTitle, items }: ConfirmationCardProps) => {
  return (
    <Card sx={{ padding: '0', height: 'fit-content' }}>
      <Typography variant="h6" sx={{ fontWeight: '500', padding: '1rem' }} className="confirmation-card-title">
        {cardTitle}
      </Typography>
      <Divider variant="fullWidth" />
      <Stack sx={{ padding: '1rem' }} gap="1rem">
        {items.map((item) =>
          item.autoPayEnrolled ? (
            <Paper sx={{ backgroundColor: '#F7F5F1' }}>
              <Typography
                className={`confirmation-item-${item.className}`}
                variant="b3Regular"
                sx={{ color: '#404040', padding: '0.5rem' }}
              >
                Auto Pay: <strong>Enrolled</strong>
              </Typography>
            </Paper>
          ) : (
            <Box key={item.title} className={`confirmation-item-${item.className}`}>
              <Typography variant="b3Regular" className="confirmation-item-title">
                {item.title}
              </Typography>
              <Stack direction="column">
                <Stack direction="row" justifyContent="space-between" alignItems="center">
                  <Typography
                    variant="b1Regular"
                    sx={{ fontWeight: '500', overflowWrap: 'anywhere' }}
                    className="confirmation-item-detail"
                    data-qm-block={item.mask ? 'true' : 'false'}
                  >
                    {item.details}
                  </Typography>
                  {item.cardLastFour && (
                    <Stack direction="row" alignItems="center" gap="0.375rem">
                      {item.iconName && (
                        <Icon
                          iconName={item.iconName}
                          sx={{ fontSize: '2.125rem' }}
                          className="confirmation-item-card-icon"
                        ></Icon>
                      )}
                      <Typography className="confirmation-item-card-last-four">••••{item.cardLastFour}</Typography>
                    </Stack>
                  )}
                </Stack>
                {item.downloadMembershipCard && (
                  <Link
                    variant="b2Regular"
                    sx={{ color: '#1C4DA6' }}
                    className="confirmation-item-download-membership-card"
                    onClick={() => {
                      window.open(generateMembershipCardUrl(), '_blank');
                    }}
                  >
                    Download membership card
                  </Link>
                )}

                {item.effectiveDate && (
                  <Typography
                    variant="b3Regular"
                    sx={{ color: '#681DA8' }}
                    className="confirmation-item-effective-date"
                  >
                    Effective on {item.effectiveDate}
                  </Typography>
                )}
                {item.isMonthlyBillPlan && (
                  <Typography
                    variant="b3Regular"
                    sx={{ color: '#681DA8' }}
                    className="confirmation-item-monthly-message"
                  >
                    Effective within 2 billing cycles
                  </Typography>
                )}
              </Stack>
            </Box>
          )
        )}
      </Stack>
    </Card>
  );
};
